export default {
/*   "source": {
      "Violent crime": "Crime Survey for England and Wales",
      "Knife and sharp instruments": "Police recorded crime",
      "Homicide": "Police recorded crime",
      "Theft": "Crime Survey for England and Wales",
      "Burglary": "Police recorded crime",
      "Vehicle offences": "Police recorded crime",
      "Robbery": "Police recorded crime",
      "Fraud": "Crime Survey for England and Wales",
      "Computer misuse": "Crime Survey for England and Wales"
   },
   "metric": {
      "Violent crime": "Number of incidents",
      "Knife and sharp instruments": "Number of incidents",
      "Homicide": "Number of incidents",
      "Theft": "Number of incidents",
      "Burglary": "Number of incidents",
      "Vehicle offences": "Number of incidents ",
      "Robbery": "Number of incidents",
      "Fraud": "Number of incidents",
      "Computer misuse": "Number of incidents"
   },*/
   "Jan '81 to Dec '81": {
      "Violent crime": "2063000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "6292000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan '83 to Dec '83": {
      "Violent crime": "2014000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "7136000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan '87 to Dec '87": {
      "Violent crime": "2265000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "8227000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan '91 to Dec '91": {
      "Violent crime": "2900000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "9792000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan '93 to Dec '93": {
      "Violent crime": "3768000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "11512000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan '95 to Dec '95": {
      "Violent crime": "4464000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "11615000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan '97 to Dec '97": {
      "Violent crime": "3746000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "10023000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan '99 to Dec '99": {
      "Violent crime": "3375000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "8584000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '01 to Mar '02": {
      "Violent crime": "2551000",
      "Knife and sharp instruments": null,
      "Homicide": null,
      "Theft": "7209000",
      "Burglary": null,
      "Vehicle offences": null,
      "Robbery": null,
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '02 to Mar '03": {
      "Violent crime": "2579000",
      "Knife and sharp instruments": null,
      "Homicide": "1047",
      "Theft": "6928000",
      "Burglary": "890099",
      "Vehicle offences": "1074659",
      "Robbery": "110271",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '03 to Mar '04": {
      "Violent crime": "2355000",
      "Knife and sharp instruments": null,
      "Homicide": "904",
      "Theft": "6518000",
      "Burglary": "820013",
      "Vehicle offences": "985006",
      "Robbery": "103736",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '04 to Mar '05": {
      "Violent crime": "2191000",
      "Knife and sharp instruments": null,
      "Homicide": "868",
      "Theft": "5815000",
      "Burglary": "680358",
      "Vehicle offences": "820096",
      "Robbery": "91010",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '05 to Mar '06": {
      "Violent crime": "2221000",
      "Knife and sharp instruments": null,
      "Homicide": "764",
      "Theft": "5660000",
      "Burglary": "645068",
      "Vehicle offences": "792821",
      "Robbery": "98198",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '06 to Mar '07": {
      "Violent crime": "2287000",
      "Knife and sharp instruments": null,
      "Homicide": "758",
      "Theft": "5641000",
      "Burglary": "622012",
      "Vehicle offences": "765015",
      "Robbery": "101376",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '07 to Mar '08": {
      "Violent crime": "1975000",
      "Knife and sharp instruments": null,
      "Homicide": "775",
      "Theft": "5126000",
      "Burglary": "583710",
      "Vehicle offences": "656453",
      "Robbery": "84773",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '08 to Mar '09": {
      "Violent crime": "1889000",
      "Knife and sharp instruments": null,
      "Homicide": "664",
      "Theft": "5583000",
      "Burglary": "581584",
      "Vehicle offences": "591853",
      "Robbery": "80130",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '09 to Mar '10": {
      "Violent crime": "1841000",
      "Knife and sharp instruments": null,
      "Homicide": "620",
      "Theft": "4989000",
      "Burglary": "540645",
      "Vehicle offences": "494873",
      "Robbery": "75105",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '10 to Mar '11": {
      "Violent crime": "2126000",
      "Knife and sharp instruments": "33917",
      "Homicide": "639",
      "Theft": "5172000",
      "Burglary": "522683",
      "Vehicle offences": "449616",
      "Robbery": "76189",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '11 to Mar '12": {
      "Violent crime": "1956000",
      "Knife and sharp instruments": "31915",
      "Homicide": "553",
      "Theft": "5360000",
      "Burglary": "501048",
      "Vehicle offences": "417442",
      "Robbery": "74688",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '12 to Mar '13": {
      "Violent crime": "1936000",
      "Knife and sharp instruments": "27228",
      "Homicide": "558",
      "Theft": "4883000",
      "Burglary": "459795",
      "Vehicle offences": "387359",
      "Robbery": "65155",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '13 to Mar '14": {
      "Violent crime": "1562000",
      "Knife and sharp instruments": "26630",
      "Homicide": "533",
      "Theft": "4379000",
      "Burglary": "443212",
      "Vehicle offences": "372041",
      "Robbery": "57828",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '14 to Mar '15": {
      "Violent crime": "1726000",
      "Knife and sharp instruments": "27418",
      "Homicide": "539",
      "Theft": "4026000",
      "Burglary": "410866",
      "Vehicle offences": "349522",
      "Robbery": "50154",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '15 to Mar '16": {
      "Violent crime": "1468000",
      "Knife and sharp instruments": "30962",
      "Homicide": "577",
      "Theft": "3698000",
      "Burglary": "401775",
      "Vehicle offences": "366715",
      "Robbery": "51232",
      "Fraud": null,
      "Computer misuse": null
   },
   "Apr '16 to Mar '17": {
      "Violent crime": "1432000",
      "Knife and sharp instruments": "37845",
      "Homicide": "706",
      "Theft": "3327000",
      "Burglary": "412248",
      "Vehicle offences": "407547",
      "Robbery": "59415",
      "Fraud": "3395000",
      "Computer misuse": "1764000"
   },
   "Apr '17 to Mar '18": {
      "Violent crime": "1426000",
      "Knife and sharp instruments": "45586",
      "Homicide": "709",
      "Theft": "3578000",
      "Burglary": "437499",
      "Vehicle offences": "457066",
      "Robbery": "77250",
      "Fraud": "3255000",
      "Computer misuse": "1227000"
   },
   "Apr '18 to Mar '19": {
      "Violent crime": "1344000",
      "Knife and sharp instruments": "49215",
      "Homicide": "674",
      "Theft": "3750000",
      "Burglary": "421866",
      "Vehicle offences": "468456",
      "Robbery": "85930",
      "Fraud": "3809000",
      "Computer misuse": "966000"
   },
   "Apr '19 to Mar '20": {
      "Violent crime": "1239000",
      "Knife and sharp instruments": "51045",
      "Homicide": "708",
      "Theft": "3299000",
      "Burglary": "378872",
      "Vehicle offences": "462124",
      "Robbery": "89534",
      "Fraud": "3675000",
      "Computer misuse": "876000"
   },
   "Jan '20 to Dec '21": {
      "Violent crime": null,
      "Knife and sharp instruments": "42755",
      "Homicide": "666",
      "Theft": null,
      "Burglary": "254495",
      "Vehicle offences": "345192",
      "Robbery": "61865",
      "Fraud": null,
      "Computer misuse": null
   },
   "Jan ' 21 to Dec '22": {
      "Fraud": "3651000",
      "Theft": "2636000",
      "Violent crime": "1079000",
      "Computer misuse": "764000",
      "Vehicle offences": "393637",
      "Burglary": "271519",
      "Robbery": "71387",
      "Knife and sharp instruments": "45879",
      "Homicide": "632",

   }
}